@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.container {
  position: relative;
  width: 100%;

  @include mobile {
    width: 100%;
  }
}
.input {
  padding:10px 10px 4px 5px;
  display: block;
  border: none;
  font-size: 1.125rem;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 1rem;
  border-bottom: 1px solid $grey;
  color: $grey;
  outline: none;
  font-family: inherit;

  &::placeholder {
    color: $grey-light;
    font-weight: 300;
  }

  &:placeholder-shown {
    border-bottom: 1px solid $grey-light;
    padding-bottom: 0.25rem;
  }

  &:hover,
  &:focus {
    color: $grey;
    border-bottom: 1px solid $grey;
    padding-bottom: 0.25rem;

    &::placeholder {
      color: $grey;
    }
  }
}
.dropdown {
  @include card-background;
  position: absolute;
  width: 100%;
  list-style: none;
  margin: 1px 0 2rem;
  padding: .5rem 0;
  cursor: pointer;
  z-index: 10;
  top: 2.5rem;

  li {
    padding-left: 2rem;
    line-height: 3rem;
  }

  li:hover {
    background-color: $grey-background;
  }
}

.icon {

  position: absolute;
  right: 0;
  top:0;
  padding: 10px;

  &.search svg {
    width: 20px;
    height: 20px;
    vertical-align: center;
  }

  &.times svg {
    width: 23px;
    height: 23px;
    vertical-align: center;
    cursor: pointer;
  }
}

/* Solid icons get a fill */
.solid {
  fill: $grey-light;
  stroke: none
}

